export const KeywordTrackingAllTexts = {
  keywordTrackingTutorial: 'Keyword Tracking Tutorials',
  keywordTracking: 'Keyword Tracking',
  keywordMonitoringFrequency: 'Keyword Monitoring Frequency',
  keywordsYourWebsiteCurrentlyRanksFor:
    'Keywords Your Website Currently Ranks For',
  keywordTrackingDesc:
    'Enter the keywords you want to track to start monitoring their performance over time. This feature allows you to see how your SEO efforts impact your keyword rankings, providing insights into progress and growth.',
  keywordMonitoringFrequencyDesc:
    'Please choose how often you’d like to update your keyword data. You can adjust this frequency anytime using the settings button on the results page.',
  selectLocation: 'Select location(s)',
  selectDevice: 'Select device',
  desktop: 'Desktop',
  mobile: 'Mobile',
  enterKeywords: 'Enter keywords',
  keywordsToTrack: 'Keywords to Track: ',
  trackKeywords: 'Track Keywords',
  textAreaPlaceHolder: 'Enter keywords separated by commas or new lines',
  import: 'Import',
  keywordsAvailable: 'keywords available',
  addKeywordsToTrack: 'Add Keywords to Track',
  limitExceeds:
    "Limit exceeded! You can't add more keywords. Please remove a country or keyword.",
  noCountriesError: 'Please select at least one location to proceed.',
  tutorialLink: 'https://youtu.be/rAjnEsWbRDQ',
  keywordTrackingTool: 'Keyword Tracking Tool',
  keywordTrackingToolDesc:
    'See how your SEO efforts impact your keyword rankings',
  noKeywordsDataFound: 'No keywords found.',
  oneKeywordAdded: '1 keyword has been successfully added.',
  upgradeSuccessMessage: 'Your subscription has been upgraded successfully'
};

export const keywordTrackingTableHeaders = [
  'Keywords',
  'Position',
  'Volume',
  'URL'
];

export const keywordTrackingToolTipRowTexts = [
  '',
  `Position - The top position your website ranks for in the organic search results for a keyword.`,
  `Volume - this is the total number of people that search for this keyword on Google, per month, in your selected geography.`,
  'URL - This column shows the page on your competitors website, which ranks for the keyword shown.'
];

export const KeywordTrackingResultTexts = {
  keywordTracking: 'Keyword Tracking',
  addKeywords: 'Add Keywords ',
  avgPosition: 'Avg Position',
  estTraffic: 'Est Traffic',
  positions: 'Positions',
  keywords: 'Keywords',
  allKeywords: 'All Keywords',
  deleteKeyword: 'Delete Keyword',
  deleteKeywordDesc: 'Are you sure you want to delete the keyword ',
  deleteKeywordDescTwo:
    '? This action is irreversible and you will lose this data.',
  deleteMultipleKeywords: 'Delete Multiple Keywords',
  delete: 'Delete',
  cancel: 'Cancel',
  keywordsTrackingFrequency: 'Keywords Tracking Frequency',
  keywordsTrackingFrequencyDesc:
    'Adjust how often your keywords are tracked. Switch between weekly and monthly tracking anytime.',
  nextUpdate: 'Next update: ',
  apply: 'Apply',
  addKeywordButtonTooltip: `You've reached the keyword tracking limit. To add new keywords, please remove some of the existing ones or buy more keywords. `,
  loadingMessage: 'Updating the keyword data please wait...'
};

export const keywordTrackingToolTipCardTexts = {
  organicTraffic: `This is the average ranking position of all the keywords being tracked. Note: day-to-day rankings on search results may vary based on where you search from, Google updates and SEO work from competitors.`,
  estTraffic: `The estimated traffic this website receives from the tracked keywords. This is based on the search volume and ranking position of each keyword.`,
  position: `This provides an overview of where your keywords rank and their overall movements, from 1-3, 4-10, 11-20 and 21+. Note, positions 1-10 are on page 1 of Google, 11-20 is page 2 and 21+ is page 3 and above`,
  backLinks: `- this shows the number of backlinks this site has. Backlinks are links from other websites to this one - the more high-quality backlinks a website has, the higher its domain authority and chances of ranking for competitive keywords. Quality and quantity is important when it comes to backlinks.`,
  domainAuthorityHead: 'Domain Authority (DR)'
};
export const KeywordTrackingResultTableHeaders = [
  'Keywords',
  'Device',
  'Position',
  'Volume',
  'Estimated Traffic',
  'Location',
  'URL',
  'Last Update',
  ''
];

export const exportCsvIcon = '/static/images/icons/download.svg';

export const keywordTrackingResultTableToolTipRowTexts = [
  '',
  'Device - The device this keyword is being tracked on (i.e. are we tracking the Google rank if someone searches on a desktop or mobile - this position might be different).',
  `Position - The top position your website ranks for in the organic search results for a keyword.`,
  'Search Volume - this is the total number of people that search for this keyword on Google, per month, in your selected geography.',
  'Estimated Traffic - An estimation of the number of monthly visits that your website gets from organic search for the tracked keyword.',
  'Location - Shows a particular location (country or US state) that a given keyword is being tracked in.',
  'URL - This column shows the page on your competitors website, which ranks for the keyword shown.',
  'Last Update - date this keyword search was completed on.'
];

export const keywordTrackingUpgradeTexts = {
  keywordTracking: 'Keyword Tracking',
  unlock: 'Unlock Keyword Tracking Tools',
  desc: 'Access keyword tracking by upgrading to SEOSpace’s Expert plan or selecting our Keyword Tracking Add-On.',
  learnMore: 'Learn More',
  confirmUpgrade: 'Upgrade to Expert',
  addYourSite: 'Add Your Site',
  addDesc:
    'Add your Squarespace website to learn how to improve your SEO, without the jargon!',
  watchTutorial: 'Watch Tutorial (06:16)',
  unlockBtn: 'Keyword Tracking Add-On',
  unlockBackLinkBtn: 'Backlink Analysis Add-On',
  unlockLocalSeoBtn: 'Add Local SEO'
};
